import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-request-verify-yourself",
  templateUrl: "./card-request-verify-yourself.component.html",
  standalone:false,
  styleUrls: ["./card-request-verify-yourself.component.scss"],
})
export class CardRequestVerifyYourselfComponent implements OnInit {
  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {}

  back() {
    this.location.back();
  }
}
